import _classCallCheck from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";
import _inherits from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/insertrowcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { findAncestor } from "./utils";
/**
 * The insert row command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as `'insertTableRowBelow'` and
 * `'insertTableRowAbove'` editor commands.
 *
 * To insert a row below the selected cell, execute the following command:
 *
 *		editor.execute( 'insertTableRowBelow' );
 *
 * To insert a row above the selected cell, execute the following command:
 *
 *		editor.execute( 'insertTableRowAbove' );
 *
 * @extends module:core/command~Command
 */

var InsertRowCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(InsertRowCommand, _Command);

  /**
   * Creates a new `InsertRowCommand` instance.
   *
   * @param {module:core/editor/editor~Editor} editor The editor on which this command will be used.
   * @param {Object} options
   * @param {String} [options.order="below"] The order of insertion relative to the row in which the caret is located.
   * Possible values: `"above"` and `"below"`.
   */
  function InsertRowCommand(editor) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, InsertRowCommand);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InsertRowCommand).call(this, editor));
    /**
     * The order of insertion relative to the row in which the caret is located.
     *
     * @readonly
     * @member {String} module:table/commands/insertrowcommand~InsertRowCommand#order
     */

    _this.order = options.order || 'below';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InsertRowCommand, [{
    key: "refresh",
    value: function refresh() {
      var selection = this.editor.model.document.selection;
      var tableParent = findAncestor('table', selection.getFirstPosition());
      this.isEnabled = !!tableParent;
    }
    /**
     * Executes the command.
     *
     * Depending on the command's {@link #order} value, it inserts a row `'below'` or `'above'` the row in which selection is set.
     *
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var editor = this.editor;
      var selection = editor.model.document.selection;
      var tableUtils = editor.plugins.get('TableUtils');
      var tableCell = findAncestor('tableCell', selection.getFirstPosition());
      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var row = table.getChildIndex(tableRow);
      var insertAt = this.order === 'below' ? row + 1 : row;
      tableUtils.insertRows(table, {
        rows: 1,
        at: insertAt
      });
    }
  }]);

  return InsertRowCommand;
}(Command);

export { InsertRowCommand as default };